<template>
    <li
        :class="{ active }"
        class="cielo-dropdown-item"
    >
        <button
            @click="$emit('click')"
            class="cielo-dropdown-item__cta"
            role="option"
            :aria-selected="active"
            :tabindex="isOptionsOpen ? '0' : '-1'"
        >
            <span v-if="this.langOptions" class="cielo-dropdown-item__text" v-text="$ml.get('DisplayText')" />
            <span v-if="!this.langOptions" class="cielo-dropdown-item__text">{{ this.canTranslate ? $ml.get(displayText) : displayText }}</span>
            <small v-if="this.item.grossAmount">{{ `(R$ ` + this.item.grossAmount + `)` }}</small>
        </button>
    </li>
</template>

<script>
  import { MLBuilder } from 'vue-multilanguage';
  import { Options } from '@/config/lang/genericOptions.js';

  export default {
      props: {
          active: {
              type: Boolean
          },
          displayText: {
              type: [String, Number],
              default: null
          },
          langOptions: {
              type: Options,
              default: null
          },
          isOptionsOpen: {
            type: Boolean
          },
          item: {
            type: Object,
            default: null
          },
		  canTranslate: {
            type: Boolean,
            default: false
          }
      },

      computed: {
          mlDisplayText() {
              if(!this.langOptions)
                  return;

              const builder = new MLBuilder(this.langOptions.langParameterName);

              this.langOptions.tokens.forEach((token) => {
                  builder.with(token.key, token.value);
              });

              return builder;
          }
      }
  };
</script>

<style lang="scss" scoped>
    .cielo-dropdown-item {
        &.active {
            .cielo-dropdown-item__cta {
                color: #0774E7;
            }
        }

        &:focus-visible {
           outline: none;
        }

        &__cta {
            background-color: transparent;
            border: none;
            padding: 8px;
            font-size: 16px;
            line-height: 24px;
            font-weight: 500;
            color: #2f363e;
            width: 100%;
            text-align: left;

            &:hover,
            &:focus {
                background-color: #EAEEF3;
                color: #0774E7;
            }

            small {
                margin-left: 8px;
            }
        }
    }

</style>
